import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  readonly rootUrl!: string;
  http = inject(HttpClient)
  constructor() { 
    this.rootUrl = environment.baseUrl;
  }
}
